import { Injectable, OnInit } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';

import { Artikel } from '../models/artikel.model';
import { SettingsService } from '../services/settings.service';


@Injectable()
export class ArtikelService implements OnInit{

    private controllerURL = 'ArtikelListe'; // Controllername in der API
    apiURL: string ;                        // URL to web API (API + Controller)
    
    artikelStore: Artikel[] = [];
    artikelStore2: Artikel[] = [];
    
    artikelEin: Artikel;

    body: string;
    query: string = "";
  // Testartikel <<<<<<<<<<<<<<<<<<<<<<<<
    artikel1: Artikel;
    artikel2: Artikel;
  
    constructor(private settings: SettingsService,
                private http: Http) {
  
      // create URL to web API
      this.apiURL = this.settings.getURL(this.controllerURL);
      console.log("apiURL = " + this.apiURL);
  
    }

    ngOnInit(): void {
  
    }

    // leert die Array mit Artikel
    // wird beim Abmelden aufgerufen
    Initialisieren(): void {
      this.artikelStore = [];
      this.artikelStore2 = [];
      this.artikelEin = new Artikel();
    }

    getArtikelliste(sucheUeber: string, vergleich: string, suchBegriff: string, 
                    top: string, mitBestand: boolean): Observable<Artikel[]> {
      
      // Artikelstore leeren
      this.artikelStore2 = [];
      
      // Filterstring bilden
      this.query = [
        `${sucheUeber}`,
        `${vergleich}`,
        `'${suchBegriff}'`
      ].join(' '); 
      // bei contains muss der Filter anders zusammengesetzt werden:
      // contains(Feldname,'suchbegriff')
      if ( vergleich === "contains") {
          this.query = [
            `contains(${sucheUeber},`,
            `'${suchBegriff}')`
            ].join(''); 
      }

      if ( mitBestand === true)   {
        const query2: string= [
          this.query,
          ` and ATLsiLagerBestand gt 0`,  // Bestand > 0
        ].join(' '); 
        this.query = query2;
      }
            
      const params: string = [
        `$filter=${this.query}`,
        `$orderby=${sucheUeber}`,
        `$top=${top}`
      ].join('&'); 
      const queryUrl = `${this.apiURL}?${params}`;
      console.log("queryURL = " + queryUrl);
      
      const headers: Headers = this.settings.getHeader();
      const opts: RequestOptions = new RequestOptions();
      opts.headers = headers;
      opts.body = "";  
      
      this.http.get(queryUrl, opts)
        .map(response => response.json())
        .subscribe (
          artData => {
              this.artikelStore = artData.value;
              this.artikelStore.forEach(einArtikel => {
                  this.artikelEin = einArtikel;
 //                 console.log( "Artikelnr: " + this.artikelEin.ATArtikelnummer);
                  this.artikelStore2.push(this.artikelEin);
                  console.log(this.artikelEin);
              })
              this.artikelStore = this.artikelStore2 ;
              return Observable.of(this.artikelStore);
          },
          error => {
            this.handleError(error) ;
            return Observable.of(this.artikelStore2); // Sollte leer sein
          }

   
        );

        return Observable.of(this.artikelStore2); // Sollte leer sein
    }


    // Einen einzelnen Artikel lesen und zurückgeben -----------------------------------
    // GET http://localhost:62281/odata/ArtikelListe('5')
    getArtikelSingle(artnr: string): Observable<Artikel> {
      
      // Artikelstore leeren
      this.artikelEin = new Artikel;
    
      const queryUrl = `${this.apiURL}('${artnr}')`;
      console.log("queryURL = " + queryUrl);
      
      const headers: Headers = this.settings.getHeader();
      const opts: RequestOptions = new RequestOptions();
      opts.headers = headers;
      opts.body = "";  
      
      this.http
        .get(queryUrl, opts)
        .map(response => response.json())
        .subscribe ( artData => {
              console.log(artData);
              this.artikelEin.ATArtikelnummer = artData.ATArtikelnummer;
              this.artikelEin.ATVariante = artData.ATVariante;
              this.artikelEin.ATBezeichnung1 = artData.ATBezeichnung1;
              this.artikelEin.ATBezeichnung2 = artData.ATBezeichnung2;
              this.artikelEin.ATSuchbegriff = artData.ATSuchbegriff;
              this.artikelEin.ATBuchungseinheit = artData.ATBuchungseinheit;
              this.artikelEin.ATEANNummer = artData.ATEANNummer;
              this.artikelEin.ATGUID = artData.ATGUID;
              this.artikelEin.ATArtikelgruppe = artData.ATArtikelgruppe;
              this.artikelEin.ATHoehe_Pal = artData.ATHoehe_Pal;
              this.artikelEin.ATKilo = artData.ATKilo;
              this.artikelEin.ATMass = artData.ATMass;

              this.artikelEin.ATLagerME = artData.ATLagerME;

              this.artikelEin.ATVPETransport = artData.ATVPETransport;
              this.artikelEin.ATLsiLHMBestand = artData.ATLsiLHMBestand;

              this.artikelEin.ATVPE = artData.ATVPE;
              this.artikelEin.ATVPEMenge = artData.ATVPEMenge;
              this.artikelEin.ATLsiVPEBestand = artData.ATLsiVPEBestand;

              this.artikelEin.ATVPEInhalt = artData.ATVPEInhalt;
              this.artikelEin.ATLsiLagerBestand = artData.ATLsiLagerBestand;

              console.log(this.artikelEin);
              return Observable.of(this.artikelEin);
              },
          error => {
            this.handleError(error) ;
            return Observable.of(this.artikelEin); // Sollte leer sein
          }
        );
        return Observable.of(this.artikelEin); // Sollte leer sein
    }

// Fehlerbehandlung -----------------------------------------------------------------
    private handleError(error: any): Observable<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Observable.of(error.message || error);
    }

     

    // TEST TEST TEST <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
    searchArtikel(query: string): Artikel[] { 

      // TEST TEST TEST
      this.createTestartikel();
      return this.artikelStore; 
    }

    // TEST TEST TEST <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
    searchListe(query: string): Observable<Artikel[]> {
      // TEST TEST TEST
      this.createTestartikel();
     return Observable.of(this.artikelStore);
    }

  
    // TEST TEST TEST <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
    createTestartikel(): void {
      this.artikelStore = new Array<Artikel>();

      this.artikel1 = new Artikel();
      this.artikel1.ATArtikelnummer = '10050536';
      this.artikel1.ATVariante = '0';
      this.artikel1.ATEANNummer ='4012345678120';
      this.artikel1.ATBezeichnung1 = 'KNAX Gewürzgruken 150ml';
      this.artikel1.ATBezeichnung2 = '';
      this.artikel1.ATSuchbegriff = 'KNAX',
      this.artikel1.ATGUID = '';
      this.artikel1.ATMass = '';
      this.artikel1.ATKilo = 1.5;
      this.artikel1.ATArtikelgruppe = '001';
      this.artikel1.ATBuchungseinheit = '1';
      this.artikel1.ATVPETransport = 'PE';
      this.artikel1.ATHoehe_Pal = 95;
      this.artikel1.ATLsiLHMBestand = 12;
      this.artikel1.ATVPEMenge = 60;
      this.artikel1.ATVPE = 'Karton';
      this.artikel1.ATLsiVPEBestand = 720;
      this.artikel1.ATVPEInhalt = 20;
      this.artikel1.ATLsiLagerBestand = 14400;
      this.artikel1.ATLagerME = 'Stk';
      this.artikelStore.push(this.artikel1);

      this.artikel2 = new Artikel();
      this.artikel2.ATArtikelnummer = '10066636';
      this.artikel2.ATVariante = '0';
      this.artikel2.ATEANNummer ='4012346668126';
      this.artikel2.ATBezeichnung1 = 'Mildessa Sauerkraut 200ml';
      this.artikel2.ATBezeichnung2 = '';
      this.artikel2.ATSuchbegriff = 'Mildessa',
      this.artikel2.ATGUID = '';
      this.artikel2.ATMass = '';
      this.artikel2.ATKilo = 0.75;
      this.artikel2.ATArtikelgruppe = '001';
      this.artikel2.ATBuchungseinheit = '1';
      this.artikel2.ATVPETransport = 'PE';
      this.artikel2.ATHoehe_Pal = 120;
      this.artikel2.ATLsiLHMBestand = 30;
      this.artikel2.ATVPEMenge = 40;
      this.artikel2.ATVPE = 'Karton';
      this.artikel2.ATLsiVPEBestand = 1200;
      this.artikel2.ATVPEInhalt = 6;
      this.artikel2.ATLsiLagerBestand = 7200;
      this.artikel2.ATLagerME = 'Stk';
      this.artikelStore.push(this.artikel2);
   }

}



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/services/artikel.service.ts